import { createTheme } from "@mui/material/styles";

export const theme = createTheme({
  palette: {
    // use for mui components like Button and input
    primary: {
      main: "#00ADE6",
      light: "#dc3545",
      dark: "#00ADE6",
    },
    // use for typo color and line
    secondary: {
      main: "#dc3545",
      light: "#00ADE6",
    },
  },
});
